import React, { useState, useEffect, useContext } from "react";
import { Modal, TextField, Card, TextStyle } from "@shopify/polaris";
import { useMutation } from "@apollo/react-hooks";
import { updateOrderNote } from "app/orders/apollo/updateOrderNote";

import baseHelper from "lib/helpers/base";
import constant from "lib/constant/constant";
import { PrivateContext } from "lib/context";
import { errorHelper } from "lib/helpers";

const Notes = (props) => {
  const { match, cms } = useContext(PrivateContext);
  const { dataItem, note, onRefetchOrderView, setBanner, setMessage } = props;
  const [disabledButton, setDisabledButton] = useState(true);
  const [notes, setNotes] = useState(note);
  const [initialNotes, setInitialNotes] = useState(note);
  const [notesModal, setNotesModal] = useState(false);
  const [updateNewNotes, setUpdateNewNotes] = useState(true);

  const [updateNotes, { loading: loadingNote, error: errorNote, data: dataNote }] = useMutation(updateOrderNote);

  const updateNote = () => {
    const noteValue = initialNotes.trim();
    const formValues = {
      note: initialNotes.trim(),
      // sellerId: dataItem.sellerId,
      // shopifyOrderId: dataItem.shopifyOrderId,
      id: match.params.id,
    };
    updateNotes({ variables: { input: formValues } });
    setUpdateNewNotes(true);
  };
  useEffect(() => {
    if (dataNote && updateNewNotes) {
      const responseNote = baseHelper.getResponseData(dataNote, constant.gql.UPDATE_ORDER_NOTE);
      const responseNoteError = baseHelper.getResponseError(dataNote, constant.gql.UPDATE_ORDER_NOTE);
      if (responseNote) {
        setNotesModal(false);
        setNotes(initialNotes);
        setMessage(cms("message.success.noteUpdated"));
        onRefetchOrderView();
      }
      if (responseNoteError) {
        setNotesModal(false);
        setBanner({
          status: constant.CRITICAL,
          title: errorHelper.parse(responseNoteError),
          isOpen: true,
        });
      }
      setUpdateNewNotes(false);
    }
  }, [dataNote, initialNotes, onRefetchOrderView, setBanner, errorHelper, updateNewNotes]);

  useEffect(() => {
    setNotesModal(false);
    if (errorNote) {
      setBanner({
        status: constant.CRITICAL,
        title: errorHelper.parse(errorNote),
        isOpen: true,
      });
    }
  }, [errorNote, setBanner, errorHelper]);

  const onUpdateNote = (value) => {
    setInitialNotes(value);
    setDisabledButton(!value);
  };

  const renderUpdateNotes = () => {
    return (
      <>
        <Modal
          open={notesModal}
          onClose={() => {
            setNotesModal(false);
            setInitialNotes(notes);
          }}
          title={cms("label.updateNote")}
          primaryAction={{
            content: cms("label.updateNote"),
            onAction: () => updateNote(),
            loading: loadingNote,
          }}
          sectioned
        >
          <Modal.Section>
            <TextField
              label={cms("label.note")}
              maxLength={5000}
              value={initialNotes}
              onChange={(val) => {
                onUpdateNote(val);
              }}
            />
          </Modal.Section>
        </Modal>
      </>
    );
  };

  return [
    renderUpdateNotes(),
    <Card
      title={cms("label.note")}
      actions={[
        {
          content: cms("label.edit"),
          onAction: () => {
            setNotesModal(true);
            setDisabledButton(true);
          },
        },
      ]}
    >
      <Card.Section>
        <div className="notes">
          <TextStyle variation={!notes && constant.SUBDUED}>{notes.trim() || cms("label.noNotes")}</TextStyle>
        </div>
      </Card.Section>
    </Card>,
  ];
};

export default Notes;
